import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BigValueLogo from '../common/BigValueLogo';

const Header: React.FC = () => {
  const [isApiDocsOpen, setIsApiDocsOpen] = useState(false);
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <BigValueLogo width={32} height={32} />
              <span className="text-2xl font-bold text-gray-900">빅밸류</span>
            </Link>
          </div>

          {/* 데스크톱 메뉴 */}
          <div className="hidden md:flex items-center space-x-8">
            {/* API 문서 드롭다운 */}
            <div
              className="relative group"
              onMouseEnter={() => setIsApiDocsOpen(true)}
              onMouseLeave={() => setIsApiDocsOpen(false)}
            >
              <button
                className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium flex items-center"
                onClick={() => setIsApiDocsOpen(!isApiDocsOpen)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsApiDocsOpen(!isApiDocsOpen);
                  }
                }}
                aria-expanded={isApiDocsOpen}
                aria-haspopup="true"
                aria-label="API 문서 메뉴"
              >
                API 문서
                <svg className="ml-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {isApiDocsOpen && (
                <div
                  className="absolute left-0 mt-0 pt-2 w-56 z-10"
                  role="menu"
                  aria-orientation="vertical"
                >
                  <div className="bg-white rounded-md shadow-lg py-1 border border-gray-200">
                    <Link to="/api-docs/realestate" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">부동산 데이터</Link>
                    <Link to="/api-docs/business" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">사업자 데이터</Link>
                    <Link to="/api-docs/card" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">카드 데이터</Link>
                  </div>
                </div>
              )}
            </div>

            {/* 개발자 도구 드롭다운 */}
            <div
              className="relative group"
              onMouseEnter={() => setIsDevToolsOpen(true)}
              onMouseLeave={() => setIsDevToolsOpen(false)}
            >
              <button
                className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium flex items-center"
                onClick={() => setIsDevToolsOpen(!isDevToolsOpen)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsDevToolsOpen(!isDevToolsOpen);
                  }
                }}
                aria-expanded={isDevToolsOpen}
                aria-haspopup="true"
                aria-label="개발자 도구 메뉴"
              >
                개발자 도구
                <svg className="ml-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {isDevToolsOpen && (
                <div
                  className="absolute left-0 mt-0 pt-2 w-56 z-10"
                  role="menu"
                  aria-orientation="vertical"
                >
                  <div className="bg-white rounded-md shadow-lg py-1 border border-gray-200">
                    <Link to="/developer-tools/api-test" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">API 테스트</Link>
                    <Link to="/developer-tools/sandbox" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">샌드박스</Link>
                    <Link to="/developer-tools/sdk" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">SDK 다운로드</Link>
                    <Link to="/developer-tools/code-samples" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">코드 샘플</Link>
                  </div>
                </div>
              )}
            </div>

            {/* 지원 드롭다운 */}
            <div
              className="relative group"
              onMouseEnter={() => setIsSupportOpen(true)}
              onMouseLeave={() => setIsSupportOpen(false)}
            >
              <button
                className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium flex items-center"
                onClick={() => setIsSupportOpen(!isSupportOpen)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsSupportOpen(!isSupportOpen);
                  }
                }}
                aria-expanded={isSupportOpen}
                aria-haspopup="true"
                aria-label="지원 메뉴"
              >
                지원
                <svg className="ml-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {isSupportOpen && (
                <div
                  className="absolute left-0 mt-0 pt-2 w-56 z-10"
                  role="menu"
                  aria-orientation="vertical"
                >
                  <div className="bg-white rounded-md shadow-lg py-1 border border-gray-200">
                    <Link to="/support/getting-started" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">시작하기</Link>
                    <Link to="/support/faq" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">FAQ</Link>
                    <Link to="/support/community" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-700">커뮤니티</Link>
                  </div>
                </div>
              )}
            </div>

            <Link to="/pricing" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              요금제
            </Link>

            <Link to="/about" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              회사 소개
            </Link>
          </div>

          {/* 우측 버튼 */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/dashboard" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              대시보드
            </Link>
            <Link to="/login" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              로그인
            </Link>
            <Link to="/signup" className="bg-primary-500 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all shadow-sm hover:shadow-md">
              무료로 시작하기
            </Link>
          </div>

          {/* 모바일 메뉴 버튼 */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-primary-600 p-2"
              aria-label="메뉴 열기"
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-menu"
            >
              <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* 모바일 메뉴 */}
        {isMobileMenuOpen && (
          <div id="mobile-menu" className="md:hidden py-4 border-t">
            <div className="space-y-2">
              <div className="px-3 py-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">API 문서</p>
                <Link to="/api-docs/realestate" className="block px-3 py-2 text-sm text-gray-700">부동산 데이터</Link>
                <Link to="/api-docs/business" className="block px-3 py-2 text-sm text-gray-700">사업자 데이터</Link>
                <Link to="/api-docs/card" className="block px-3 py-2 text-sm text-gray-700">카드 데이터</Link>
              </div>
              <div className="px-3 py-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">개발자 도구</p>
                <Link to="/developer-tools/api-test" className="block px-3 py-2 text-sm text-gray-700">API 테스트</Link>
                <Link to="/developer-tools/sandbox" className="block px-3 py-2 text-sm text-gray-700">샌드박스</Link>
                <Link to="/developer-tools/sdk" className="block px-3 py-2 text-sm text-gray-700">SDK 다운로드</Link>
              </div>
              <div className="px-3 py-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">지원</p>
                <Link to="/support/getting-started" className="block px-3 py-2 text-sm text-gray-700">시작하기</Link>
                <Link to="/support/faq" className="block px-3 py-2 text-sm text-gray-700">FAQ</Link>
                <Link to="/support/community" className="block px-3 py-2 text-sm text-gray-700">커뮤니티</Link>
              </div>
              <Link to="/pricing" className="block px-6 py-2 text-sm text-gray-700">요금제</Link>
              <Link to="/about" className="block px-6 py-2 text-sm text-gray-700">회사 소개</Link>
              <Link to="/dashboard" className="block px-6 py-2 text-sm text-gray-700">대시보드</Link>
              <div className="px-6 py-2 space-y-2">
                <Link to="/login" className="block text-center border-2 border-primary-500 text-primary-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-primary-50 transition-colors">
                  로그인
                </Link>
                <Link to="/signup" className="block text-center bg-primary-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors">
                  무료로 시작하기
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
